
export class SystemSetting {
  public id: string;
  public settingID: number;
  public siteName: string;
  public siteTitle: string;
  public siteUrl: string;
  public siteCopyright: string;
  public siteUAN: string;
  public siteControlPanelTitle: string;
  public administratorEmail: string;
  public defaultCurrency: string;
  public currencySymbol: string;
  public defaultTimezone: string
  public dateFormat: string;
  public timeFormat: string;
  public metaTagKeywords: string;
  public metaTagDescription: string;
  public googleAnalyticsCode: string;
  public webmasterEmbeddedCode: string;
  public siteLogo: string;
  public siteFavIcon: string;
  public siteHeaderCss: string;
  public justForUProductLimit: number;
}



// WEBPACK FOOTER //
// ./src/app/models/system-setting/system-setting.model.ts